<template>
    <div id="flow-list1" :class="{ 'flow-list': true, 'ht-scroll-vertical': true, batch: checked }">
        <form class="search-form" action="javascript:void(0)">
            <van-search
                disabled
                background="transparent"
                placeholder="点击搜索"
                :clearable="false"
                @click="onSearchClick"
            />
            <van-button
                :class="{ cancle: !checked }"
                size="small"
                @click="batchProcessing"
                v-if="type == 'todo' && isBatchHandle == 'true'"
            >
                {{ buttonText }}
            </van-button>
        </form>
        <div
            v-if="!!innerSearchJson"
            class="ht-text-assist"
            @click="onResetSearchClick"
            style="margin-bottom: 10px; text-align: center"
        >
            点击显示全部
        </div>

        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
            style="padding: 0 15px"
            v-if="!emptyShow"
        >
            <FlowListItem
                v-for="(item, index) in list"
                :key="index"
                :type="type"
                :item="item"
                :checked="checked"
                :ids="ids"
                @itemCheck="itemCheck"
                @deleteHandler="deleteHandler"
            />
        </van-list>
        <div class="empty-container" v-else>
            <Error type="empty" />
        </div>
        <div class="batch-handle" v-if="checked">
            <div class="batch-check">
                <div :class="{ 'check-box': true, checked: allCheck }" @click="allCheckHandle"></div>
                全选
            </div>
            <div class="button-box">
                <van-button color="var(--main-color)" block @click="showHandle">处理</van-button>
            </div>
        </div>
        <van-popup v-model="show" position="bottom">
            <div class="apply-handle">
                <van-button color="var(--main-color)" block @click="complete" v-if="isComplete == true">
                    完成
                </van-button>
                <van-button color="var(--main-color)" block @click="passByIds">直接通过</van-button>
                <van-button color="var(--main-color)" block @click="handleNext('SUBMIT')">填写意见并通过</van-button>
                <van-button color="var(--main-color)" block @click="handleNext('FINISH')">中止</van-button>
                <van-button color="var(--main-color)" block @click="show = false">取消</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import { List, Button, Search, Icon, Popup, Toast } from "vant"
    import FlowListItem from "@/components/Flow/FlowListItem"
    import { queryList, batchHandleCooperative, batchEndCooperative, checkBatchEnd } from "@/api/flow"
    import { getPlatformInstance } from "@/platforms"

    export default {
        name: "FlowList",
        components: {
            [List.name]: List,
            [Search.name]: Search,
            [Icon.name]: Icon,
            [Button.name]: Button,
            [Popup.name]: Popup,
            FlowListItem,
        },
        props: ["type", "flowKey", "searchJson", "searchFieldJson"],
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                error: false,
                pageIndex: 0,
                innerSearchJson: "",
                innerSearchFieldJson: "",
                emptyShow: false, //空空如也是否显示
                checked: false,
                buttonText: "批量管理",
                ids: [],
                allCheck: false,
                show: false,
                isBatchHandle: "false",
                isComplete: false,
            }
        },
        computed: {},
        created() {
            const TITLE = {
                all: "全部事项",
                send: "已发",
                todo: "待办事项",
                done: "已办事项",
                doneOngoing: "已办事项",
                doneEnd: "已办事项",
                copy: "抄送给我",
                copyOngoing: "抄送给我",
                copyEnd: "抄送给我",
                reply: "最新回复",
                draft: "草稿箱",
                ongoing: "进行中",
                end: "已结束",
            }
            getPlatformInstance().then(platform => platform.setTitle(TITLE[this.type]))
            this.innerSearchJson = this.searchJson
            this.innerSearchFieldJson = this.searchFieldJson
        },
        methods: {
            onLoad() {
                this.loading = true
                queryList(this.type, this.flowKey, this.pageIndex, this.innerSearchJson, this.innerSearchFieldJson)
                    .then(resp => {
                        this.isBatchHandle = resp.isBatchHandle ? resp.isBatchHandle : "false"
                        if (resp.data) {
                            this.allCheck = false
                            this.list = this.list.concat(resp.data)
                            console.log("this.list: ", this.list)
                            if (this.list && this.list.length > 0) {
                                let query = {
                                    instIds: this.list[0].id,
                                }
                                checkBatchEnd(query).then(res => {
                                    console.log("res: ", res)
                                    if (res) {
                                        this.isComplete = res
                                    } else {
                                        this.isComplete = false
                                        this.error = false
                                    }
                                }).catch(error => {
                                    this.error = true
                                })
                            } else {
                                console.log(555555);
                            }

                            if (this.list.length >= resp.total) {
                                this.finished = true
                            }
                            if (!resp.total || resp.total == 0) {
                                this.emptyShow = true
                                this.error = false
                            } else {
                                this.emptyShow = false
                            }
                            this.pageIndex++
                            this.loading = false
                        } else {
                            this.loading = false
                            if (this.list && this.list.length == 0) {
                                this.emptyShow = true
                            }
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        this.error = true
                        // this.$router.push('/empty/error')
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            deleteHandler(id) {
                this.list = this.list.filter(item => item.id != id)
            },
            onSearchClick() {
                let flowId = ""
                if (this.list.length > 0 && this.list[0].wfInfoId) {
                    flowId = this.list[0].wfInfoId
                    this.$router.push({
                        name: "FLOW_LIST_SEARCH",
                        params: {
                            flowId: flowId,
                            type: this.type,
                            flowKey: this.flowKey,
                            innerSearchJson: this.innerSearchJson,
                            searchFieldJson: this.innerSearchFieldJson,
                        },
                    })
                } else {
                    queryList(this.type, this.flowKey, 0).then(res => {
                        if (res.data && res.data.length > 0) {
                            flowId = res.data[0].wfInfoId
                            this.$router.push({
                                name: "FLOW_LIST_SEARCH",
                                params: {
                                    flowId: flowId,
                                    type: this.type,
                                    flowKey: this.flowKey,
                                    innerSearchJson: this.innerSearchJson,
                                    searchFieldJson: this.innerSearchFieldJson,
                                },
                            })
                        } else {
                            flowId = ""
                            this.$router.push({
                                name: "FLOW_LIST_SEARCH",
                                params: {
                                    flowId: flowId,
                                    type: this.type,
                                    flowKey: this.flowKey,
                                    innerSearchJson: this.innerSearchJson,
                                    searchFieldJson: this.innerSearchFieldJson,
                                },
                            })
                        }
                    })
                }
            },
            batchProcessing() {
                //批量处理
                this.allCheck = false
                this.checked = !this.checked
                this.checked ? (this.buttonText = "取消") : (this.buttonText = "批量管理")
                this.ids = []
            },
            itemCheck(id) {
                this.allCheck = false
                if (this.ids.indexOf(id) == -1) {
                    this.ids.push(id)
                    if (this.ids.length == this.list.length) {
                        this.allCheck = true
                    }
                } else {
                    let index = this.ids.indexOf(id)
                    this.ids.splice(index, 1)
                }
            },
            allCheckHandle() {
                this.allCheck = !this.allCheck
                this.ids = []
                if (this.allCheck) {
                    this.list.forEach(item => {
                        this.ids.push(item.id)
                    })
                }
            },
            showHandle() {
                if (this.ids.length > 0) {
                    this.show = true
                } else {
                    Toast.fail("至少选择一项!")
                    //    http://localhost:8080/eip/cooperative/batchHandleCooperative.htm
                }
            },
            handleNext(type) {
                this.$router.push({ name: "FLOW_APPROVE", params: { type: type, ids: this.ids } })
            },
            getFlowId() {
                let flowId = ""
                queryList(this.type, this.flowKey, 0).then(res => {
                    if (res.data && res.data.length > 0) {
                        flowId = res.data[0].wfInfoId
                    }
                })
            },
            onResetSearchClick() {
                this.$router.push({ path: `/flow/list/${this.type}/${this.flowKey}` })
                this.loading = false
                this.finished = false
                this.error = false
                this.pageIndex = 0
                this.innerSearchJson = ""
                this.innerSearchFieldJson = ""
                this.list = []
                this.onLoad()
            },
            complete() {
                let completeToast = Toast({
                    message: "处理中...",
                    forbidClick: true,
                    loadingType: "spinner",
                    duration: 0,
                })
                let params = {
                    instIds: this.ids.join(","),
                    logJson: JSON.stringify({ logmsg: "", handWritePath: "", logtype: "cooper", optype: "SUBMIT" }),
                    annexJson: [],
                }
                batchEndCooperative(params).then(res => {
                    if (res && res.code == 200) {
                        Toast.clear()
                        Toast.success(res.msg || "操作成功!")
                        this.checked = false
                        this.buttonText = "批量管理"
                        this.allCheck = false
                        this.show = false
                        this.ids = []
                        this.loading = true
                        this.finished = false
                        this.list = []
                        this.pageIndex = 0
                        this.onLoad()
                    } else {
                        Toast.fail(res.msg || "操作失败!")
                        this.loading = true
                        this.finished = false
                        this.list = []
                        this.pageIndex = 0
                        completeToast.clear()
                        this.onLoad()
                    }
                })
            },
            passByIds() {
                let passToast = Toast({
                    message: "处理中...",
                    forbidClick: true,
                    loadingType: "spinner",
                    duration: 3000,
                })
                // let params = '{ instIds: ' + this.ids.join(',') + ', logJson: { logmsg:"", handWritePath:"", ogtype:"cooper", optype:"SUBMIT" },annexJson: []}';
                // var string = 'a[b][c][d][e][f][g][h][i]=j';
                // console.log(QS.parse(params));
                let params = {
                    instIds: this.ids.join(","),
                    logJson: JSON.stringify({ logmsg: "", handWritePath: "", ogtype: "cooper", optype: "SUBMIT" }),
                    annexJson: [],
                }
                batchHandleCooperative(params).then(res => {
                    if (res && res.code == 200) {
                        this.checked = false
                        this.buttonText = "批量管理"
                        this.allCheck = false
                        this.show = false
                        this.ids = []
                        this.loading = true
                        this.finished = false
                        this.list = []
                        this.pageIndex = 0
                        passToast.clear()
                        this.onLoad()
                        Toast.success({
                            message: res.msg || "操作成功!",
                            forbidClick: true,
                            loadingType: "spinner",
                            duration: 1000,
                        })
                    } else {
                        Toast.fail(res.msg || "操作失败!")
                        this.loading = true
                        this.finished = false
                        this.list = []
                        this.pageIndex = 0
                        passToast.clear()
                        this.onLoad()
                    }
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .search-form {
        display: flex;
        .van-search {
            flex: 1;
        }
        .van-button {
            height: 34px;
            margin: 10px 15px 10px 0;
            background: var(--main-color);
            color: #fff;
            font-size: 12px;
            border-radius: 6px;
        }
    }
    .flow-list {
        height: 100vh;
        box-sizing: border-box;
        background: #FFFFFF url("../../assets/image/new-ui/bg.png") no-repeat;
        background-size: 100%;
        &.batch {
            padding-bottom: 50px;
        }
        .van-search {
            padding: 10px 15px;
        }

        .van-search__content {
            background-color: #ffffff;
        }
    }
    .batch-handle {
        display: flex;
        box-sizing: border-box;
        height: 86px;
        line-height: 50px;
        padding: 20px 15px 0;
        background: #FFFFFF;
        box-shadow: 0px -4px 12px 0px rgba(0,0,0,0.08);
        border-radius: 6px 6px 0px 0px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        .batch-check {
            height: 50px;
            padding: 0 25px;
            font-size: 16px;
            position: relative;
            .check-box {
                display: block;
                box-sizing: border-box;
                width: 20px;
                height: 20px;
                color: transparent;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                border: 1px solid var(--main-color);
                transition-duration: var(--main-color);
                transition-property: color, border-color, background-color;
                border-radius: 10px;
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -10px;
                &.checked {
                    background: var(--main-color);
                    &:before {
                        content: "";
                        display: inline-block;
                        width: 12px;
                        height: 6px;
                        border-left: 1px solid #ffffff;
                        border-bottom: 1px solid #ffffff;
                        position: absolute;
                        top: 3px;
                        left: 3px;
                        transform: rotate(-45deg);
                    }
                }
            }
        }
        .button-box {
            height: 40px;
            padding: 5px 0;
            flex: 1;
            .van-button {
                height: 40px;
                border-radius: 6px;
            }
        }
    }
    .van-popup {
        height: 255px;
        .apply-handle {
            padding: 20px 15px;
            .van-button {
                height: 35px;
                margin-bottom: 10px;
                &:last-of-type {
                    margin: 0;
                }
            }
        }
    }
</style>
